import { ICustomResponse } from '../interfaces/businessData';

export const DEFAULT_CUSTOM_RESPONSE_MOCK: { data: ICustomResponse } = {
  data: {
    statusCode: 200,
    message: 'Success'
  }
};
